import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header.component';
import { SvgModule } from '../svg/svg.module';
import { RouterModule } from '@angular/router';
import { MenuItemComponent } from 'src/app/components/menu-item/menu-item.component';
import { MenuItemListTitleComponent } from 'src/app/components/menu-item-list-title/menu-item-list-title.component';
import { TranslationModule } from 'src/app/i18n/translation.module';
import { FormsModule } from '@angular/forms';
import { MenuItemOurStoryModule } from '../menu-item-our-story/menu-item-our-story.module';
import { LangSwitcherModule } from '../lang-switcher/lang-switcher.module';
import { ModalModule } from '../modal/modal.module';
import { CheckboxModule } from '../checkbox/checkbox.module';
import { DirectivesModule } from '../directives/directives.module';
import { SearchHeaderModule } from '../search-header/search-header.module';
import { BtnOneModule } from '../btn-one/btn-one.module';
import { CountDownTimerModule } from '../count-down-timer/count-down-timer.module';
import { HeaderCarouselModule } from '../header-carousel/header-carousel.module';
import { LoaderTwoModule } from '../loader-two/loader-two.module';
import { ModalDivModule } from "../modal-div/modal-div.module";


@NgModule({
  declarations: [
    HeaderComponent,
    MenuItemComponent,
    MenuItemListTitleComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    SvgModule,
    TranslationModule,
    FormsModule,
    MenuItemOurStoryModule,
    LangSwitcherModule,
    ModalModule,
    CheckboxModule,
    DirectivesModule,
    SearchHeaderModule,
    BtnOneModule,
    CountDownTimerModule,
    HeaderCarouselModule,
    LoaderTwoModule,
    ModalDivModule
],
  exports: [HeaderComponent]
})
export class HeaderModule { }
